import React from 'react'
import { connect } from 'react-redux'
import Rodal from 'rodal'
import { externalNewsletterDispatchers as dispatchers } from 'reduxModules/users/dispatchers'
import { externalNewsletterReselector as selector } from 'reduxModules/users/selectors'
import ExternalEmailFunnelDialog from '../App/ExternalEmailFunnelDialog/index.jsx'

function ExternalEmailFunnel(props) {
  const onCloseDialog = () => {
    props.closeDialog()
    props.updateDeclinedExternalNewsletter()
  }
  return (
    <div id="ExternalEmailFunnelModal">
      <Rodal
        visible={props.externalFunnelDialogIsOpen}
        onClose={onCloseDialog}
        width={props.isMobile ? 375 : 800}
        height={300}
      >
        <ExternalEmailFunnelDialog isPopUp tag="External Email Funnel" onSubmit={props.onSubmit} />
      </Rodal>
    </div>
  )
}

export default connect(selector, dispatchers)(ExternalEmailFunnel)
